<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">登录日志</li>
    </ul>
    <ul class="c-list-table" style="margin-top: 10px">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column prop="admin_name" label="登录用户" />
        <el-table-column
          prop="ip"
          label="ip地址"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="msg"
          label="说明"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="create_time"
          sortable="create_time"
          label="登录时间"
          min-width="180"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '角色'"
        @close="state.showInfo = false"
      >
        <c_RoleInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_RoleInfo>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showYh"
        title="绑定用户"
        @close="state.showYh = false"
      >
        <c_RoleBindYh
          @close="
            state.showYh = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_RoleBindYh>
      </c_popup>
    </transition>
    <el-drawer
      v-model="state.showQx"
      :key="state.key"
      :with-header="false"
      size="50%"
    >
      <c_RoleSetQx
        :id="state.selectId"
        @close="state.showQx = false"
      ></c_RoleSetQx>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { loginlog_list } from "@/http/api";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      loginlog_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    return {
      state,
      onLoad,
    };
  },
};
</script>
<style scoped></style>
